import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

export const AutoDeleteModal = ({
  handleDeleteAccount,
  isAutoDeleteModal,
  setIsAutoDeleteModal,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={isAutoDeleteModal} onHide={(e) => setIsAutoDeleteModal(false)}>
      <Modal.Body>
        <div className="promocode_content cancelmembership deletemodel">
          <Link to="" onClick={(e) => setIsAutoDeleteModal(false)}>
            +
          </Link>
          <h2>
            <img src={window.location.origin + "/images/warning.svg"} />
            <br />
            {t("Delete Account")}
          </h2>
          <div className="cancelmembershipp">
            <p>{t("Are you sure you want to delete your account?")} </p>
            <div className="button text-center">
              <div className="pull-right">
                <button className="btn" onClick={(e) => handleDeleteAccount()}>
                  {t("text-delete")}
                </button>
              </div>
              <div className="pull-right">
                <button
                  className="btn confirm"
                  onClick={(e) => setIsAutoDeleteModal(false)}
                >
                  {t("text-cancel")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
